import React, {
  createContext,
  type FunctionComponent,
  type ReactNode,
  useContext,
} from 'react';

const ScopeContext = createContext('main');

export interface ScopeProps {
  scope: string;
  children: ReactNode;
}

const Scope: FunctionComponent<ScopeProps> = ({ scope, children }) => (
  <ScopeContext.Provider value={scope}>{children}</ScopeContext.Provider>
);

export default Scope;

/** @deprecated Concept of scope no longer applies and can be removed from code */
export function useScope(): string {
  return useContext(ScopeContext);
}
